import classNames from 'clsx';
import React from 'react';

import LoadingIndicator from '@swf/components/LoadingIndicator/LoadingIndicator';

import useThemeMode from '../../hooks/useThemeMode';

import styles from './Loader.scss';

interface Props {
  loading: boolean;
  className?: string;
}

const Loader: React.FC<Props> = ({ loading, children, className }) => {
  const { darkMode } = useThemeMode();

  return (
    <LoadingIndicator
      className={classNames(styles.container, className)}
      loading={loading}
      variant={darkMode ? 'light' : 'dark'}
    >
      {children}
    </LoadingIndicator>
  );
};

export default Loader;
